var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3204 5.93414C17.559 1.15122 11.4431 -0.487537 6.66016 2.27389C1.87724 5.03531 0.238481 11.1512 2.9999 15.9341C5.76133 20.7171 11.8772 22.3558 16.6602 19.5944C19.0205 18.2317 20.6151 16.052 21.2931 13.6188M20.3204 5.93414L15.3627 5.93414M20.3204 5.93414L20.2999 0.80309",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circle-arrow.47e4dfcd476d2c1335abb224ccb7ae8d.svg";
export { ForwardRef as ReactComponent };